/** UI option shape: key = label, value = option value */
export type Option<T> = { key: string; value: T };

/** Options for creating enum filters */
export interface CreateEnumFiltersOptions<T extends string | number> {
  excludeKeys?: (string | number)[];
  prepend?: Option<T | "all">[];
  append?: Option<T | "all">[];
}

/** Creates filter options from enum map (enum key → display name). Reusable across pages. */
export const createEnumFilters = <T extends string | number>(
  enumMap: Record<string | number, string>,
  filterOptions: CreateEnumFiltersOptions<T> = {},
): Option<T | "all">[] => {
  const { excludeKeys = [], prepend = [], append = [] } = filterOptions;

  const stringExcludeKeys = excludeKeys.map(String);

  const enumOptions = Object.entries(enumMap)
    .filter(([key]) => !stringExcludeKeys.includes(key))
    .map(([key, name]) => {
      const parsedVal = isNaN(Number(key)) ? key : Number(key);
      return { key: name, value: parsedVal as T };
    });

  return [...prepend, ...enumOptions, ...append];
};
